import React from 'react';

const ModulesArchitectureDiagram: React.FC = () => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-lg transition-all duration-300">
      <h2 className="mb-6 text-2xl font-bold text-center text-blue-800">功能模块架构图</h2>
      <p className="mb-4 text-gray-600 text-center max-w-4xl mx-auto">
        Fusion和X-Ray系统功能模块架构概览
      </p>
      
      <div className="flex flex-col lg:flex-row gap-6">
        {/* Fusion系统模块 - 更新为基于文章的内容 */}
        <div className="flex-1 bg-gradient-to-br from-red-50 to-red-100 rounded-lg p-4 border-2 border-red-200 shadow-md">
          <h3 className="text-xl font-semibold text-red-800 text-center mb-4">Fusion 系统</h3>
          
          <div className="bg-white rounded-lg p-3 mb-3 shadow-sm border border-red-200">
            <h4 className="font-medium text-red-700 mb-2">实货交易模块</h4>
            <div className="grid grid-cols-2 gap-2">
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">贸易管理</span>
                <p className="text-xs text-gray-600 mt-1">支持交易全流程管理</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">库存管理</span>
                <p className="text-xs text-gray-600 mt-1">实时库存余量跟踪</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">物流管理</span>
                <p className="text-xs text-gray-600 mt-1">运输路径与进展跟踪</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">质量管理</span>
                <p className="text-xs text-gray-600 mt-1">产品质量监控与索赔</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg p-3 mb-3 shadow-sm border border-red-200">
            <h4 className="font-medium text-red-700 mb-2">金融交易模块</h4>
            <div className="grid grid-cols-2 gap-2">
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">套期保值</span>
                <p className="text-xs text-gray-600 mt-1">保值计划管理</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">期货交易</span>
                <p className="text-xs text-gray-600 mt-1">期货合约管理</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">市场监控</span>
                <p className="text-xs text-gray-600 mt-1">价格变化实时跟踪</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">结算管理</span>
                <p className="text-xs text-gray-600 mt-1">期货交易结算管理</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg p-3 mb-3 shadow-sm border border-red-200">
            <h4 className="font-medium text-red-700 mb-2">风险管理模块</h4>
            <div className="grid grid-cols-2 gap-2">
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">市场风险</span>
                <p className="text-xs text-gray-600 mt-1">盯市计算与风险敞口</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">信用风险</span>
                <p className="text-xs text-gray-600 mt-1">交易对手额度管理</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">合规风险</span>
                <p className="text-xs text-gray-600 mt-1">交易合规性监控</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">风险报表</span>
                <p className="text-xs text-gray-600 mt-1">实时盈亏分析报表</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg p-3 mb-3 shadow-sm border border-red-200">
            <h4 className="font-medium text-red-700 mb-2">财务管理模块</h4>
            <div className="grid grid-cols-2 gap-2">
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">结算管理</span>
                <p className="text-xs text-gray-600 mt-1">多维度结算处理</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">资金管理</span>
                <p className="text-xs text-gray-600 mt-1">资金流向与规划</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">收入成本</span>
                <p className="text-xs text-gray-600 mt-1">精准收入成本核算</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">尾款管理</span>
                <p className="text-xs text-gray-600 mt-1">尾款追踪与控制</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg p-3 shadow-sm border border-red-200">
            <h4 className="font-medium text-red-700 mb-2">协作管理模块</h4>
            <div className="grid grid-cols-2 gap-2">
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">跨部门协作</span>
                <p className="text-xs text-gray-600 mt-1">部门间协同工作</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">审批管理</span>
                <p className="text-xs text-gray-600 mt-1">自定义审批流程</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">邮件单据</span>
                <p className="text-xs text-gray-600 mt-1">单据邮件管理</p>
              </div>
              <div className="bg-red-50 p-2 rounded text-sm">
                <span className="font-medium">数据管理</span>
                <p className="text-xs text-gray-600 mt-1">业务数据整合分析</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* X-Ray系统模块 - 更新为基于案例的内容 */}
        <div className="flex-1 bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 border-2 border-blue-200 shadow-md">
          <h3 className="text-xl font-semibold text-blue-800 text-center mb-4">X-Ray 系统</h3>
          
          <div className="bg-white rounded-lg p-3 mb-3 shadow-sm border border-blue-200">
            <h4 className="font-medium text-blue-700 mb-2">多源数据采集模块</h4>
            <div className="grid grid-cols-2 gap-2">
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">XDK采集工具包</span>
                <p className="text-xs text-gray-600 mt-1">非侵入式实时数据采集</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">API集成</span>
                <p className="text-xs text-gray-600 mt-1">多系统数据直连</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">智能文档识别</span>
                <p className="text-xs text-gray-600 mt-1">表格自动数据提取</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">跨地域采集</span>
                <p className="text-xs text-gray-600 mt-1">全球数据实时汇总</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg p-3 mb-3 shadow-sm border border-blue-200">
            <h4 className="font-medium text-blue-700 mb-2">数据标准化处理模块</h4>
            <div className="grid grid-cols-2 gap-2">
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">行业标准映射</span>
                <p className="text-xs text-gray-600 mt-1">行业标准数据转换</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">智能数据清洗</span>
                <p className="text-xs text-gray-600 mt-1">机器学习异常校正</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">多维度存储</span>
                <p className="text-xs text-gray-600 mt-1">时序数据多周期管理</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">ETL处理</span>
                <p className="text-xs text-gray-600 mt-1">数据抽取转换与加载</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg p-3 mb-3 shadow-sm border border-blue-200">
            <h4 className="font-medium text-blue-700 mb-2">数据质量保障模块</h4>
            <div className="grid grid-cols-2 gap-2">
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">自我验证机制</span>
                <p className="text-xs text-gray-600 mt-1">跨系统数据一致性检查</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">无人值守预警</span>
                <p className="text-xs text-gray-600 mt-1">AI异常监控与通知</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">日终作业机制</span>
                <p className="text-xs text-gray-600 mt-1">数据完整性校验</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">质量评分</span>
                <p className="text-xs text-gray-600 mt-1">数据质量评估体系</p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg p-3 shadow-sm border border-blue-200">
            <h4 className="font-medium text-blue-700 mb-2">数据应用服务模块</h4>
            <div className="grid grid-cols-2 gap-2">
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">实时报表</span>
                <p className="text-xs text-gray-600 mt-1">高效报表自动生成</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">数据可视化</span>
                <p className="text-xs text-gray-600 mt-1">交互式数据展示</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">数据API</span>
                <p className="text-xs text-gray-600 mt-1">微服务数据接口</p>
              </div>
              <div className="bg-blue-50 p-2 rounded text-sm">
                <span className="font-medium">安全控制</span>
                <p className="text-xs text-gray-600 mt-1">多层数据访问权限</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* 公共基础服务层 */}
      <div className="mt-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-4 border-2 border-gray-200 shadow-md">
        <h3 className="text-xl font-semibold text-gray-700 text-center mb-4">公共基础服务层</h3>
        
        <div className="grid grid-cols-5 gap-3">
          <div className="bg-white p-3 rounded shadow-sm text-center border border-gray-300">
            <div className="font-medium text-gray-700">认证授权</div>
            <div className="text-xs text-gray-500 mt-1">身份验证与权限控制</div>
          </div>
          <div className="bg-white p-3 rounded shadow-sm text-center border border-gray-300">
            <div className="font-medium text-gray-700">数据服务</div>
            <div className="text-xs text-gray-500 mt-1">统一数据访问接口</div>
          </div>
          <div className="bg-white p-3 rounded shadow-sm text-center border border-gray-300">
            <div className="font-medium text-gray-700">消息队列</div>
            <div className="text-xs text-gray-500 mt-1">系统间异步通信</div>
          </div>
          <div className="bg-white p-3 rounded shadow-sm text-center border border-gray-300">
            <div className="font-medium text-gray-700">调度服务</div>
            <div className="text-xs text-gray-500 mt-1">任务调度与管理</div>
          </div>
          <div className="bg-white p-3 rounded shadow-sm text-center border border-gray-300">
            <div className="font-medium text-gray-700">缓存服务</div>
            <div className="text-xs text-gray-500 mt-1">高性能数据缓存</div>
          </div>
        </div>
      </div>
      
      <div className="mt-6 p-4 bg-blue-50 rounded-lg shadow-sm">
        <h3 className="font-semibold text-blue-800 mb-2">功能模块架构说明</h3>
        <p className="text-sm text-gray-700">
          功能模块架构包含Fusion系统与X-Ray系统两大核心系统，以及支撑两系统运行的公共基础服务层。
          Fusion系统是专业的交易与风险管理工具，集成了实货交易、金融交易、风险管理、财务管理和协作管理等模块，将专业交易工具和通用管理平台功能融合，
          为大宗贸易企业提供全面的解决方案，帮助企业高效管理交易全流程并有效控制多维度风险。
          X-Ray系统是一款企业级数据治理与挖掘平台，专注于多源数据采集、标准化处理与质量保障，能够无缝整合企业各类数据源，
          解决数据孤岛问题，提高数据质量和分析效率，为企业决策提供强大的数据支持。
          公共基础服务层为两系统提供认证授权、数据服务、消息队列等基础能力支撑。
          整体模块架构设计遵循高内聚低耦合原则，支持灵活扩展与维护。
        </p>
      </div>
    </div>
  );
};

export default ModulesArchitectureDiagram; 